import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { FilterProps } from "../../types";
import Filter from "../Filter";
import { IFilter } from "../Filter/types";
import { SearchBarProps } from "../SearchBar";
import SearchInput from "../SearchBar/SearchInput";
import FilterTabs, { FilterTab } from "../TableFilter";

export interface CouponFilterBarProps<TKeys extends string = string>
  extends FilterProps<TKeys>,
    SearchBarProps {
  filterStructure: IFilter<TKeys>;
  hideAction?: boolean;
  disablePlusOneTab?: boolean;
  customAction?: {
    disabled?: boolean;
    displayOn?: boolean;
    label?: {
      className?: string;
      value: string;
    };
    onClick?: () => void;
    className?: string;
  };
  onClearPagination?: (boolean) => void;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(1, 3)
    },
    tabActionButton: {
      marginLeft: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }),
  {
    name: "CouponFilterBar"
  }
);

const CouponFilterBar: React.FC<CouponFilterBarProps> = props => {
  const {
    allTabLabel,
    currencySymbol,
    filterStructure,
    currentTab,
    initialSearch,
    searchPlaceholder,
    tabs,
    hideAction,
    onAll,
    onSearchChange,
    onFilterChange,
    onTabChange,
    onTabSave,
    onClearPagination,
    disablePlusOneTab,
    customAction = {
      className: "",
      disabled: true,
      displayOn: false,
      label: {
        className: "",
        value: ""
      },
      onClick: () => null
    }
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const isCustom = currentTab === tabs.length + 1;
  const displayTabAction = hideAction
    ? null
    : isCustom
    ? "save"
    : currentTab === 0
    ? null
    : "delete";

  const { className, disabled, displayOn, label, onClick } = customAction;

  return (
    <>
      <FilterTabs currentTab={currentTab}>
        {onAll ? <FilterTab label={allTabLabel} onClick={onAll} /> : null}
        {tabs.map((tab, tabIndex) => (
          <FilterTab
            onClick={() =>
              onTabChange(disablePlusOneTab ? tabIndex : tabIndex + 1)
            }
            label={tab}
            key={tabIndex}
          />
        ))}
        {isCustom && (
          <FilterTab
            onClick={() => undefined}
            label={intl.formatMessage({
              defaultMessage: "Custom Filter"
            })}
          />
        )}
      </FilterTabs>
      <div className={classes.root}>
        <Filter
          currencySymbol={currencySymbol}
          menu={filterStructure}
          onFilterAdd={onFilterChange}
          onClearPagination={onClearPagination}
        />
        <SearchInput
          initialSearch={initialSearch}
          placeholder={searchPlaceholder}
          onSearchChange={onSearchChange}
        />
        {displayTabAction === "save" && (
          <Button
            className={classes.tabActionButton}
            color="primary"
            onClick={onTabSave}
            id="filterSaveBtn"
          >
            <FormattedMessage
              defaultMessage="Save Search"
              description="button"
            />
          </Button>
        )}

        {customAction && displayOn && (
          <Button
            className={className}
            color="primary"
            disabled={disabled}
            onClick={onClick}
            id="customActionBtn"
          >
            <label className={label.className}>{label.value}</label>
          </Button>
        )}
      </div>
    </>
  );
};
CouponFilterBar.displayName = "CouponFilterBar";
export default CouponFilterBar;
